var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import BreadcrumbItem from './BreadcrumbItem/BreadcrumbItem';
const BaseBreadcrumbs = styled.ol `
  display: flex;
  ${({ customCss }) => customCss || ''}
`;
const Breadcrumbs = (_a) => {
    var { items, small, customCss, renderItem } = _a, delegated = __rest(_a, ["items", "small", "customCss", "renderItem"]);
    return (_jsx(BaseBreadcrumbs, Object.assign({ customCss: customCss, itemScope: true, itemType: "https://schema.org/BreadcrumbList" }, delegated, { children: items.map((item, index, arr) => (_jsx(BreadcrumbItem, { index: index + 1, itemName: item.name, itemUrl: item.url, last: arr.length - 1 === index, renderItem: renderItem, small: small }, item.name))) }), void 0));
};
export default Breadcrumbs;
//# sourceMappingURL=Breadcrumbs.js.map